export var APPLE_STORE_ID = 'apple-store';
export var DEFAULT_APP_BLOCK = {
  store: {
    links: [{
      id: APPLE_STORE_ID,
      link: 'https://apps.apple.com/ru/app/moj-bilajn/id569251594',
      imgSrc: 'https://static.beeline.ru/upload/images/b2c/footer/appStore.svg',
      ariaLabel: 'Apple Store',
      fullImgSrc: 'https://static.beeline.ru/upload/images/b2c/footer/appStoreFull.svg'
    }, {
      id: 'google-play',
      link: 'https://play.google.com/store/apps/details?id=ru.beeline.services&hl=ru',
      imgSrc: 'https://static.beeline.ru/upload/images/b2c/footer/googleStore.svg',
      ariaLabel: 'Google play'
    }, {
      id: 'huawei-store',
      link: 'https://appgallery.huawei.com/app/C100716739',
      imgSrc: 'https://static.beeline.ru/upload/images/b2c/footer/appGallery.svg',
      ariaLabel: 'Huawei Store'
    }, {
      id: 'ru-store',
      link: 'https://apps.rustore.ru/app/ru.beeline.services',
      imgSrc: 'https://static.beeline.ru/upload/images/b2c/footer/ruStore.svg',
      ariaLabel: 'RuStore'
    }],
    qr: {
      qrImageUrl: 'https://static.beeline.ru/upload/images/landings/kids-sim/app-qr-code.svg',
      qrLabel: 'отcканируй QR-код,чтобы скачать'
    }
  },
  iconUrl: 'https://static.beeline.ru/upload/images/logo_app3.svg',
  phoneImageUrl: 'https://static.beeline.ru/upload/images/b2c/24688-mapp_screen.png',
  stickyImageUrl: 'https://static.beeline.ru/upload/images/landings/kids-sim/cat.svg'
};